import { Maybe } from ".codegen/generatedApi"

export type Grow<T, A extends Array<T>> = ((x: T, ...xs: A) => void) extends (
  ...a: infer X
) => void
  ? X
  : never
export type GrowToSize<T, A extends Array<T>, N extends number> = {
  0: A
  1: GrowToSize<T, Grow<T, A>, N>
}[A['length'] extends N ? 0 : 1]

export type FixedArray<T, N extends number> = GrowToSize<T, [], N>

export type Mutable<T> = {
  -readonly [k in keyof T]: T[k]
}

export type PartialRecord<T extends string | number | symbol, U> = {
  [P in T]?: U
}

export type GOptions<T extends string, O extends T | '' | undefined> = {
  [P in T]?: P extends O ? true : O extends undefined ? boolean : never
}

export interface MakeOptions<
  O extends string,
  Defaults extends O | '' | undefined = undefined
> {
  args: O | '' | undefined
  defaults: Defaults
  options: GOptions<O, Defaults>
  props: O
}


export type EnumType<T extends string> = {
  [P in Capitalize<Lowercase<`${T}`>>]: Uppercase<P>
}

export type EnumFlip<T extends string> = {
  [P in Uppercase<T>]: Capitalize<Lowercase<P>>
}

export type MaybeArray<T> = T | T[] | null | undefined

export type ObjectWithNode<T> = Maybe<{ node?: Maybe<T> }> | undefined


export const isNullish = <T extends any>(x: T | null | undefined): x is (null | undefined) => {
  return x === null || typeof x === 'undefined'
}

export const asNumber = (v: any): number => {
  return !isNaN(Number(v)) ? Number(v) : 0
}